// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
   StepProgress.css — reusable wizard stepper (see StepProgress.jsx)
   Colours: current #1E2761 → #1E67E6, completed #E7F6EF / #059669,
   upcoming border #CADCFC / icon #94A3B8, track #E2E8F0.
   ============================================================================ */

.sp {
    --sp-navy: #1E2761;
    --sp-blue: #1E67E6;
    --sp-grad: linear-gradient(135deg, #1E2761 0%, #1E67E6 100%);
    --sp-track: #E2E8F0;
    --sp-badge: 44px;
    font: inherit;
    color: #334155;
}

/* ---- header row ---------------------------------------------------------- */
.sp-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 14px;
}

.sp-head-text {
    font-size: 13px;
    color: #475569;
    white-space: nowrap;
}

    .sp-head-text strong {
        color: var(--sp-navy);
        font-weight: 700;
    }

.sp-head-dot {
    margin: 0 6px;
    color: #94A3B8;
}

.sp-head-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 0 1 220px;
    min-width: 120px;
}

.sp-head-track {
    flex: 1;
    height: 6px;
    border-radius: 999px;
    background: var(--sp-track);
    overflow: hidden;
}

.sp-head-fill {
    display: block;
    height: 100%;
    border-radius: 999px;
    background: var(--sp-grad);
    transition: width 250ms ease;
}

.sp-head-pct {
    font-size: 12px;
    font-weight: 600;
    color: var(--sp-blue);
    min-width: 34px;
    text-align: right;
    font-variant-numeric: tabular-nums;
}

/* ---- tiles --------------------------------------------------------------- */
.sp-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(var(--sp-n, 8), minmax(0, 1fr));
    align-items: start;
}

.sp-item {
    position: relative;
    min-width: 0;
}

/* connector: from this badge's centre to the next badge's centre, behind the badges */
.sp-connector {
    position: absolute;
    top: calc(var(--sp-badge) / 2 - 1px + 4px); /* badge centre (+ tile padding-top) */
    left: 50%;
    width: 100%;
    height: 2px;
    background: var(--sp-track);
    border-radius: 2px;
    overflow: hidden;
    z-index: 0;
    pointer-events: none;
}

.sp-connector-fill {
    display: block;
    width: 100%;
    height: 100%;
    background: var(--sp-grad);
    transform-origin: left center;
    transition: transform 250ms ease;
}

.sp-item:last-child .sp-connector {
    display: none;
}

.sp-tile {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 4px 2px 2px;
    margin: 0;
    background: none;
    border: 0;
    border-radius: 10px;
    font: inherit;
    color: inherit;
    text-align: center;
    cursor: default;
    transition: transform 150ms ease;
}

button.sp-tile {
    cursor: pointer;
}

    button.sp-tile:hover {
        transform: translateY(-2px);
    }

        button.sp-tile:hover .sp-badge {
            box-shadow: 0 6px 16px rgba(30, 39, 97, 0.18);
        }

    button.sp-tile:focus-visible,
    .sp-tile:focus-visible {
        outline: 2px solid var(--sp-blue);
        outline-offset: 2px;
    }

.sp-badge {
    position: relative;
    width: var(--sp-badge);
    height: var(--sp-badge);
    border-radius: 12px;
    display: grid;
    place-items: center;
    font-size: 18px;
    line-height: 1;
    background: #fff;
    border: 1.5px solid #CADCFC;
    color: #94A3B8;
    transition: box-shadow 150ms ease, background-color 150ms ease, color 150ms ease;
}

.sp-icon {
    display: inline-flex;
}

/* step number (or check) in the badge corner */
.sp-num {
    position: absolute;
    right: -6px;
    bottom: -6px;
    width: 17px;
    height: 17px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
    background: #fff;
    color: #475569;
    border: 1px solid #E2E8F0;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.sp-num-done {
    background: #059669;
    border-color: #059669;
    color: #fff;
    font-size: 9px;
}

.sp-label {
    display: block;
    font-size: 13px;
    line-height: 1.3;
    min-height: calc(13px * 1.3 * 2); /* room for two lines so tiles align */
    color: #64748B;
    overflow-wrap: normal;
    word-break: normal;
    hyphens: manual;
}

/* states */
.sp-complete .sp-badge {
    background: #E7F6EF;
    border-color: #E7F6EF;
    color: #059669;
}

.sp-complete .sp-label {
    color: #334155;
}

.sp-current .sp-badge {
    background: var(--sp-grad);
    border-color: transparent;
    color: #fff;
    box-shadow: 0 0 0 4px rgba(30, 103, 230, 0.15);
}

.sp-current .sp-num {
    color: var(--sp-blue);
    border-color: var(--sp-blue);
}

.sp-current .sp-label {
    color: var(--sp-navy);
    font-weight: 700;
}

/* ---- 640–1099px: two rows ------------------------------------------------- */
@media (max-width: 1099px) {
    .sp-list {
        grid-template-columns: repeat(var(--sp-half, 4), minmax(0, 1fr));
        row-gap: 18px;
    }

    .sp-item[data-row-end="1"] .sp-connector {
        display: none;
    }
}

/* ---- < 640px: horizontal scroll-snap strip --------------------------------- */
@media (max-width: 639px) {
    .sp-head {
        gap: 12px;
    }

    .sp-head-bar {
        flex: 0 1 140px;
        min-width: 96px;
    }

    .sp-list {
        display: flex;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        padding: 4px 4px 8px;
        margin: 0 -4px;
    }

    .sp-item {
        flex: 0 0 112px;
        scroll-snap-align: center;
    }

        .sp-item[data-row-end="1"] .sp-connector {
            display: block;
        }

    .sp-item:last-child .sp-connector {
        display: none;
    }
}

/* ---- motion -------------------------------------------------------------- */
@media (prefers-reduced-motion: reduce) {
    .sp-head-fill,
    .sp-connector-fill,
    .sp-tile,
    .sp-badge {
        transition: none !important;
    }

    .sp-list {
        scroll-behavior: auto;
    }
}
`, "",{"version":3,"sources":["webpack://./ClientApp/shared/StepProgress.css"],"names":[],"mappings":"AAAA;;;;iFAIiF;;AAEjF;IACI,kBAAkB;IAClB,kBAAkB;IAClB,4DAA4D;IAC5D,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,cAAc;AAClB;;AAEA,+EAA+E;AAC/E;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;IAEI;QACI,qBAAqB;QACrB,gBAAgB;IACpB;;AAEJ;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,WAAW;IACX,oBAAoB;IACpB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA,+EAA+E;AAC/E;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,6DAA6D;IAC7D,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA,sFAAsF;AACtF;IACI,kBAAkB;IAClB,0CAA0C,EAAE,sCAAsC;IAClF,SAAS;IACT,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,oBAAoB;IACpB,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;IAEI;QACI,2BAA2B;IAC/B;;QAEI;YACI,6CAA6C;QACjD;;IAEJ;;QAEI,iCAAiC;QACjC,mBAAmB;IACvB;;AAEJ;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,2BAA2B;IAC3B,cAAc;IACd,gFAAgF;AACpF;;AAEA;IACI,oBAAoB;AACxB;;AAEA,+CAA+C;AAC/C;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gCAAgC,EAAE,sCAAsC;IACxE,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,WAAW;AACX;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,WAAW;IACX,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,gFAAgF;AAChF;IACI;QACI,gEAAgE;QAChE,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,iFAAiF;AACjF;IACI;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,6BAA6B;QAC7B,iCAAiC;QACjC,qBAAqB;QACrB,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,yBAAyB;IAC7B;;QAEI;YACI,cAAc;QAClB;;IAEJ;QACI,aAAa;IACjB;AACJ;;AAEA,+EAA+E;AAC/E;IACI;;;;QAII,2BAA2B;IAC/B;;IAEA;QACI,qBAAqB;IACzB;AACJ","sourcesContent":["/* ============================================================================\r\n   StepProgress.css — reusable wizard stepper (see StepProgress.jsx)\r\n   Colours: current #1E2761 → #1E67E6, completed #E7F6EF / #059669,\r\n   upcoming border #CADCFC / icon #94A3B8, track #E2E8F0.\r\n   ============================================================================ */\r\n\r\n.sp {\r\n    --sp-navy: #1E2761;\r\n    --sp-blue: #1E67E6;\r\n    --sp-grad: linear-gradient(135deg, #1E2761 0%, #1E67E6 100%);\r\n    --sp-track: #E2E8F0;\r\n    --sp-badge: 44px;\r\n    font: inherit;\r\n    color: #334155;\r\n}\r\n\r\n/* ---- header row ---------------------------------------------------------- */\r\n.sp-head {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 16px;\r\n    margin-bottom: 14px;\r\n}\r\n\r\n.sp-head-text {\r\n    font-size: 13px;\r\n    color: #475569;\r\n    white-space: nowrap;\r\n}\r\n\r\n    .sp-head-text strong {\r\n        color: var(--sp-navy);\r\n        font-weight: 700;\r\n    }\r\n\r\n.sp-head-dot {\r\n    margin: 0 6px;\r\n    color: #94A3B8;\r\n}\r\n\r\n.sp-head-bar {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    flex: 0 1 220px;\r\n    min-width: 120px;\r\n}\r\n\r\n.sp-head-track {\r\n    flex: 1;\r\n    height: 6px;\r\n    border-radius: 999px;\r\n    background: var(--sp-track);\r\n    overflow: hidden;\r\n}\r\n\r\n.sp-head-fill {\r\n    display: block;\r\n    height: 100%;\r\n    border-radius: 999px;\r\n    background: var(--sp-grad);\r\n    transition: width 250ms ease;\r\n}\r\n\r\n.sp-head-pct {\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    color: var(--sp-blue);\r\n    min-width: 34px;\r\n    text-align: right;\r\n    font-variant-numeric: tabular-nums;\r\n}\r\n\r\n/* ---- tiles --------------------------------------------------------------- */\r\n.sp-list {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    display: grid;\r\n    grid-template-columns: repeat(var(--sp-n, 8), minmax(0, 1fr));\r\n    align-items: start;\r\n}\r\n\r\n.sp-item {\r\n    position: relative;\r\n    min-width: 0;\r\n}\r\n\r\n/* connector: from this badge's centre to the next badge's centre, behind the badges */\r\n.sp-connector {\r\n    position: absolute;\r\n    top: calc(var(--sp-badge) / 2 - 1px + 4px); /* badge centre (+ tile padding-top) */\r\n    left: 50%;\r\n    width: 100%;\r\n    height: 2px;\r\n    background: var(--sp-track);\r\n    border-radius: 2px;\r\n    overflow: hidden;\r\n    z-index: 0;\r\n    pointer-events: none;\r\n}\r\n\r\n.sp-connector-fill {\r\n    display: block;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: var(--sp-grad);\r\n    transform-origin: left center;\r\n    transition: transform 250ms ease;\r\n}\r\n\r\n.sp-item:last-child .sp-connector {\r\n    display: none;\r\n}\r\n\r\n.sp-tile {\r\n    position: relative;\r\n    z-index: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 8px;\r\n    width: 100%;\r\n    padding: 4px 2px 2px;\r\n    margin: 0;\r\n    background: none;\r\n    border: 0;\r\n    border-radius: 10px;\r\n    font: inherit;\r\n    color: inherit;\r\n    text-align: center;\r\n    cursor: default;\r\n    transition: transform 150ms ease;\r\n}\r\n\r\nbutton.sp-tile {\r\n    cursor: pointer;\r\n}\r\n\r\n    button.sp-tile:hover {\r\n        transform: translateY(-2px);\r\n    }\r\n\r\n        button.sp-tile:hover .sp-badge {\r\n            box-shadow: 0 6px 16px rgba(30, 39, 97, 0.18);\r\n        }\r\n\r\n    button.sp-tile:focus-visible,\r\n    .sp-tile:focus-visible {\r\n        outline: 2px solid var(--sp-blue);\r\n        outline-offset: 2px;\r\n    }\r\n\r\n.sp-badge {\r\n    position: relative;\r\n    width: var(--sp-badge);\r\n    height: var(--sp-badge);\r\n    border-radius: 12px;\r\n    display: grid;\r\n    place-items: center;\r\n    font-size: 18px;\r\n    line-height: 1;\r\n    background: #fff;\r\n    border: 1.5px solid #CADCFC;\r\n    color: #94A3B8;\r\n    transition: box-shadow 150ms ease, background-color 150ms ease, color 150ms ease;\r\n}\r\n\r\n.sp-icon {\r\n    display: inline-flex;\r\n}\r\n\r\n/* step number (or check) in the badge corner */\r\n.sp-num {\r\n    position: absolute;\r\n    right: -6px;\r\n    bottom: -6px;\r\n    width: 17px;\r\n    height: 17px;\r\n    border-radius: 50%;\r\n    display: grid;\r\n    place-items: center;\r\n    font-size: 10px;\r\n    font-weight: 700;\r\n    line-height: 1;\r\n    background: #fff;\r\n    color: #475569;\r\n    border: 1px solid #E2E8F0;\r\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\r\n}\r\n\r\n.sp-num-done {\r\n    background: #059669;\r\n    border-color: #059669;\r\n    color: #fff;\r\n    font-size: 9px;\r\n}\r\n\r\n.sp-label {\r\n    display: block;\r\n    font-size: 13px;\r\n    line-height: 1.3;\r\n    min-height: calc(13px * 1.3 * 2); /* room for two lines so tiles align */\r\n    color: #64748B;\r\n    overflow-wrap: normal;\r\n    word-break: normal;\r\n    hyphens: manual;\r\n}\r\n\r\n/* states */\r\n.sp-complete .sp-badge {\r\n    background: #E7F6EF;\r\n    border-color: #E7F6EF;\r\n    color: #059669;\r\n}\r\n\r\n.sp-complete .sp-label {\r\n    color: #334155;\r\n}\r\n\r\n.sp-current .sp-badge {\r\n    background: var(--sp-grad);\r\n    border-color: transparent;\r\n    color: #fff;\r\n    box-shadow: 0 0 0 4px rgba(30, 103, 230, 0.15);\r\n}\r\n\r\n.sp-current .sp-num {\r\n    color: var(--sp-blue);\r\n    border-color: var(--sp-blue);\r\n}\r\n\r\n.sp-current .sp-label {\r\n    color: var(--sp-navy);\r\n    font-weight: 700;\r\n}\r\n\r\n/* ---- 640–1099px: two rows ------------------------------------------------- */\r\n@media (max-width: 1099px) {\r\n    .sp-list {\r\n        grid-template-columns: repeat(var(--sp-half, 4), minmax(0, 1fr));\r\n        row-gap: 18px;\r\n    }\r\n\r\n    .sp-item[data-row-end=\"1\"] .sp-connector {\r\n        display: none;\r\n    }\r\n}\r\n\r\n/* ---- < 640px: horizontal scroll-snap strip --------------------------------- */\r\n@media (max-width: 639px) {\r\n    .sp-head {\r\n        gap: 12px;\r\n    }\r\n\r\n    .sp-head-bar {\r\n        flex: 0 1 140px;\r\n        min-width: 96px;\r\n    }\r\n\r\n    .sp-list {\r\n        display: flex;\r\n        overflow-x: auto;\r\n        scroll-snap-type: x mandatory;\r\n        -webkit-overflow-scrolling: touch;\r\n        scrollbar-width: thin;\r\n        padding: 4px 4px 8px;\r\n        margin: 0 -4px;\r\n    }\r\n\r\n    .sp-item {\r\n        flex: 0 0 112px;\r\n        scroll-snap-align: center;\r\n    }\r\n\r\n        .sp-item[data-row-end=\"1\"] .sp-connector {\r\n            display: block;\r\n        }\r\n\r\n    .sp-item:last-child .sp-connector {\r\n        display: none;\r\n    }\r\n}\r\n\r\n/* ---- motion -------------------------------------------------------------- */\r\n@media (prefers-reduced-motion: reduce) {\r\n    .sp-head-fill,\r\n    .sp-connector-fill,\r\n    .sp-tile,\r\n    .sp-badge {\r\n        transition: none !important;\r\n    }\r\n\r\n    .sp-list {\r\n        scroll-behavior: auto;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
